import React from "react";
import { useNavigate } from "react-router-dom";

const FinalCta = () => {
  const navigate = useNavigate();

  return (
    <div
      id="final-cta"
      className="w-full py-20 sm:py-24 px-4 md:px-8 text-center bg-[#050733] border-t-4 border-primaryBtnHoverColor mb-10 sm:mb-14"
    >
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white uppercase mb-6">
          Ready to Plan Your Event?
        </h2>
        <p className="text-xl font-poppins text-gray-300 mb-10">
          Tell us your group size, preferred sport, date and time. Our team will help customize the rest.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <button 
            onClick={() => navigate("/party-request")}
            className="bg-primaryBtnHoverColor hover:bg-red-800 text-white font-bold py-4 px-10 rounded-md transition duration-300 font-heading text-xl uppercase tracking-wider shadow-lg cursor-pointer hover:scale-105 active:scale-95"
          >
            Request a Party
          </button>
          
          <a 
            href="tel:+14042002954" 
            className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#050733] font-bold py-4 px-10 rounded-md transition duration-300 font-heading text-xl uppercase tracking-wider"
          >
            Call Strikes & Shots
          </a>
        </div>
      </div>
    </div>
  );
};

export default FinalCta;
